import './styles.scss'
import React, { useEffect, useState } from 'react'
import { Button } from 'primereact/button'
import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext'
import { Calendar } from 'primereact/calendar'
import { MultiSelect } from 'primereact/multiselect'
import { useTranslation } from 'react-i18next'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { TABLE_CONST } from 'Utils/Constants'
import ButtonComponent from '../ButtonComponent'

const YearMonthNavigation = (props) => {
  // Props for rendering year and month folders
  const { availableReportYears, availableReportMonths, onYearFolderClick, onMonthFolderClick, activeYearIndex, onYearDecrement, onYearIncrement, navigateToYearPage } = props

  // Props for year dropdown selection
  const { availableYearsList, yearDropdownLabelKey, yearDropdownValueKey, yearDropdownValue, handleYearDropdownChange } = props

  // Props for rendering the data table
  const { reportTableColumns = [], reportTableData = [], displaySensitiveColumns = false, tableClassName = '', loading = false, activeYear = '', activeMonth = '', navigateToMonthPage } = props

  // Props for multi-select filter dropdown
  const { showMultiSelectFilter = true, dropdownFilterOptions, multiSelectFilterValues, onMultiSelectFilterChange } = props

  // Props for search input with clear filter option
  const { searchFieldValue, onSearchInputChange, handleClearFilters } = props

  // Props for calendar date range selection
  const { maximumDate, minimumDate, selectedDateRangeValue, onDateRangeChange } = props

  // Props for advanced search dropdown filters
  const { onFilterDropdownChange, selectedFilterItems, availableFilterOptionsMap } = props

  // Props for basic text search input
  const { searchInputTextValue, handleSearchInputChange } = props

  const { t } = useTranslation()

  let viewToRender
  let rowCount = 5
  let paginationButtons = TABLE_CONST.paginationButtonCount

  const [windowSize, setWindowSize] = useState(window.innerWidth)

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize)

    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  if (windowSize < TABLE_CONST.maxWidthTab) {
    rowCount = TABLE_CONST.mobileRowCount
    paginationButtons = TABLE_CONST.mobilePaginationButtonCount
  }

  const handleWindowResize = () => {
    setWindowSize(window.innerWidth)
  }

  const getSearchValue = (field) => {
    searchFieldValue[field]?.value || ''
  }

  const renderYearReportList = () => (
    <div className="year-report-container">
      {availableReportYears?.map((item, index) => (
        <div key={index} className="year-report-item" onClick={() => onYearFolderClick(item, index)}>
          <i className="year-report-icon pi pi-folder" />
          <p className="year-report-label">{item?.year}</p>
        </div>
      ))}
    </div>
  )

  const renderMonthReportList = () => (
    <div className="month-data-container">
      <div className="navigation-header">
        <ButtonComponent type="Custom" variant="neutral" label="Back" icon="pi pi-arrow-left" onClick={navigateToYearPage} className="custom-button" />
        <div className="year-navigation">
          <Button icon="pi pi-angle-double-left" label="Previous" onClick={onYearDecrement} disabled={activeYearIndex === 0} className="p-button-text" />

          <Dropdown value={yearDropdownValue} onChange={(event) => handleYearDropdownChange(event.target.value)} options={availableYearsList} optionLabel={yearDropdownLabelKey} optionValue={yearDropdownValueKey} className="year-selector" panelClassName="year-selector-panel" appendTo={'self'} />
          <Button icon="pi pi-angle-double-right" iconPos="right" label="Next" onClick={onYearIncrement} disabled={activeYearIndex === availableReportYears.length - 1} className="p-button-text" />
        </div>
      </div>
      <div className="month-content-wrapper">
        {availableReportMonths?.months?.map((month, index) => (
          <div
            key={index}
            className="month-entry"
            onClick={() => month.count > 0 && onMonthFolderClick(month)}
            style={{
              cursor: month?.count <= 0 ? 'not-allowed' : 'pointer',
              opacity: month?.count <= 0 ? 0.5 : 1
            }}
          >
            <i className="month-icon pi pi-folder" />
            <p className="month-name">
              {month?.name} - {t('INVOICE_COUNT_LABEL')} - {month?.count}
            </p>
          </div>
        ))}
      </div>
    </div>
  )

  const renderMonthDetailView = () => (
    <div className="month-details-wrapper">
      <ButtonComponent type="Custom" variant="neutral" label="Back" icon="pi pi-arrow-left" onClick={navigateToMonthPage} />

      <div className="breadcrumb-header">
        <p>{activeYear}</p>
        <p>
          <i className="pi pi-chevron-right right-arrow-icon"></i>
        </p>
        <p>{activeMonth}</p>
      </div>

      <div className="toolbar-container">
        <div className="filter-dropdown-container">
          {showMultiSelectFilter ? (
            <MultiSelect value={multiSelectFilterValues} onChange={onMultiSelectFilterChange} options={dropdownFilterOptions} placeholder={t('FILTER')} maxSelectedLabels={1} className="filter-dropdown" panelClassName="filter-dropdown-panel" appendTo={'self'} showSelectAll={false} />
          ) : (
            <div className="search-container p-input-icon-left">
              <i className="pi pi-search" />
              <InputText value={searchInputTextValue} placeholder={t('SEARCH')} className="search-input" onChange={(e) => handleSearchInputChange(e.target.value)} />
            </div>
          )}
        </div>

        {dropdownFilterOptions
          ?.filter((opt) => multiSelectFilterValues?.includes(opt.value))
          ?.map((opt, index) => (
            <div key={index} className="filter-input">
              <span className={`p-input-icon-${opt?.type === 'calendar' ? 'right' : 'left'} input-wrapper`}>
                {opt?.type === 'text' && (
                  <>
                    <i className="pi pi-search left-icon" />
                    <InputText value={getSearchValue(opt?.value)} placeholder={opt?.label} className="search-input-field" onChange={(e) => onSearchInputChange(opt.value, e.target.value)} />
                    <i className="pi pi-times clear-icon" onClick={() => handleClearFilters(opt?.value)} />
                  </>
                )}

                {opt?.type === 'calendar' && (
                  <div className="filter-input">
                    <span className="p-input-icon-right input-wrapper">
                      <Calendar value={selectedDateRangeValue} onChange={(e) => onDateRangeChange(opt.value, e.value)} selectionMode="range" readOnlyInput hideOnRangeSelection placeholder={opt.label} minDate={minimumDate} maxDate={maximumDate} className="calendar-input-field" panelClassName="custom-calendar-panel" viewDate={minimumDate} disabled={!(minimumDate && maximumDate)} dateFormat="dd/mm/yy" />

                      <i className="pi pi-times clear-icon" onClick={() => handleClearFilters(opt.value)} />
                    </span>
                  </div>
                )}

                {opt?.type === 'dropdown' && (
                  <div className="filter-dropdown-wrapper">
                    <span className="p-input-icon-left">
                      <i className="pi pi-search" />
                      <Dropdown value={selectedFilterItems?.[opt?.value] || null} options={availableFilterOptionsMap?.[opt?.value] || []} optionLabel={opt?.value === 'Subscription Name' ? 'name' : opt?.dataField} optionValue={opt?.value === 'Subscription Name' ? 'name' : opt?.dataField} className="custom-filter-dropdown" onChange={(e) => onFilterDropdownChange(opt?.value, e.value)} placeholder={opt?.label} appendTo="self" />
                    </span>
                    <div className="filter-clear-icon" onClick={() => handleClearFilters(opt.value)}>
                      <span className="pi pi-times"></span>
                    </div>
                  </div>
                )}
              </span>
            </div>
          ))}
      </div>

      <div className="data-table-wrapper">
        <DataTable value={reportTableData} className={`month-details-data-table ${tableClassName}`} paginator={reportTableData?.length} rows={rowCount} pageLinkSize={paginationButtons} emptyMessage={loading ? t('FETCHING') : t('NO_RESULTS_FOUND')}>
          {reportTableColumns
            ?.filter((column) => {
              if (column?.dataField === 'email' || column?.dataField === 'phone') {
                return displaySensitiveColumns
              }

              return true
            })
            ?.map((column, index) => (
              <Column key={index} field={column?.dataField} header={column?.text} body={column?.body} className={column?.className} />
            ))}
        </DataTable>
      </div>
    </div>
  )

  if (!activeMonth && activeYear) {
    viewToRender = renderMonthReportList()
  } else if (activeMonth && activeYear) {
    viewToRender = renderMonthDetailView()
  } else {
    viewToRender = renderYearReportList()
  }

  return (
    <>
      <div className="year-month-nav-wrapper"> {viewToRender}</div>
    </>
  )
}

export default YearMonthNavigation
